import React from 'react';
import PropTypes from 'prop-types';
import locale from '@glu/locale';
import { Drawer as GluDrawer } from '@glu/drawer-react';
import { withStyles } from '@glu/theming';
import { XCircleNextIcon } from '@glu/icons-react';
import { Tabs, Tab } from '@glu/tabs-react';
import Columns from '../Columns/Columns';
import Filters from '../Filters/Filters';
// import { Columns, Filters } from '../../components';

import { styles } from './Drawer.styles';

export function DrawerComponent(props) {
  const {
    MultiselectFilterProps,
    TypeaheadFilterProps,
    activeTab,
    classes,
    data,
    hideColumns,
    hideFilters,
    id,
    menuOpen,
    numberFilterTypes,
    onChange,
    onDrawerToggle,
    onTabClick,
    records,
    setMenuOpen
  } = props;

  // prevent columns which only exist for UI from confusing the DnD logic (e.g. subrow control)
  if (data) {
    const sanitizedColumns = data?.columns.filter((col) => col.field);
    data.columns = sanitizedColumns;
  }

  const handleTabChange = (_, value) => {
    onTabClick(value);
  };

  const closeDrawer = () => {
    setMenuOpen(false);
  };

  return (
    <GluDrawer
      open={menuOpen}
      anchorTo="right"
      startingSize={0}
      size={450}
    >
      <div className={classes.background}>
        <button
          data-qa="drawerClose"
          className={classes.closeButton}
          onClick={onDrawerToggle}
          aria-label={locale.get('gridReact.close')}
          type="button"
        >
          <XCircleNextIcon />
        </button>
        <div className={classes.headerWrapper}>
          {menuOpen
          && (
          <Tabs value={activeTab} className={classes.tabs}>
            {!hideFilters
              && (
                <Tab value="filters" onChange={handleTabChange} className={classes.tab}>
                  {locale.get('gridReact.filters')}
                </Tab>
              )}
            {!hideColumns
              && (
              <Tab value="columns" onChange={handleTabChange} className={classes.tab}>
                {locale.get('gridReact.columns')}
              </Tab>
              )}
          </Tabs>
          )}
        </div>
        {menuOpen && activeTab === 'columns' && (
          <Columns
            activeTab={activeTab}
            classes={classes}
            dark
            data={data}
            hideColumns={hideColumns}
            hideFilters={hideFilters}
            htmlId={id}
            menuOpen={menuOpen}
            onCancel={closeDrawer}
            onChange={(...args) => { onChange(...args); closeDrawer(); }}
            onDrawerToggle={onDrawerToggle}
            onTabClick={onTabClick}
            setMenuOpen={setMenuOpen}
            options={[]}
          />
        )}
        {menuOpen && activeTab === 'filters' && (
          <div className={classes.content}>
            <Filters
              activeTab={activeTab}
              classes={classes}
              dark
              data={data}
              datePickerProps={{ forcePositionY: true }}
              filterables={data.columns.filter((col) => col.filterable !== false)}
              hideColumns={hideColumns}
              hideFilters={hideFilters}
              htmlId={id}
              menuOpen={menuOpen}
              onCancel={closeDrawer}
              onChange={(...args) => { onChange(...args); closeDrawer(); }}
              onDrawerToggle={onDrawerToggle}
              onTabClick={onTabClick}
              numberFilterTypes={numberFilterTypes}
              setMenuOpen={setMenuOpen}
              records={records}
              MultiselectFilterProps={MultiselectFilterProps}
              TypeaheadFilterProps={TypeaheadFilterProps}
            />
          </div>
        )}
      </div>
    </GluDrawer>
  );
}

DrawerComponent.propTypes = {
  MultiselectFilterProps: PropTypes.shape({}),
  TypeaheadFilterProps: PropTypes.shape({}),
  activeTab: PropTypes.string.isRequired,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  data: PropTypes.shape({
    columns: PropTypes.arrayOf(PropTypes.shape({ colId: PropTypes.string }))
  }).isRequired,
  hideColumns: PropTypes.bool,
  hideFilters: PropTypes.bool,
  id: PropTypes.string.isRequired,
  menuOpen: PropTypes.bool.isRequired,
  numberFilterTypes: PropTypes.arrayOf(
    PropTypes.shape({ text: PropTypes.string, value: PropTypes.string })
  ),
  onChange: PropTypes.func.isRequired,
  onDrawerToggle: PropTypes.func.isRequired,
  onTabClick: PropTypes.func.isRequired,
  records: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  setMenuOpen: PropTypes.func.isRequired
};

DrawerComponent.defaultProps = {
  MultiselectFilterProps: undefined,
  TypeaheadFilterProps: undefined,
  hideColumns: false,
  hideFilters: false,
  numberFilterTypes: undefined
};

export default withStyles(styles)(DrawerComponent);
